module.exports = __webpack_public_path__ + "static/media/synopsis-correlations-and-automated-charting-01.f55bcdb1.png";